<script lang="ts">
    
    import { navigate } from "svelte-navigator";
    import { sessionService } from "../Services";

    const { isLoggedIn } = sessionService;

    if (!$isLoggedIn) {
        navigate('/');
    }

</script>

{#if $isLoggedIn}
    <slot />
{/if}
